import {Group as MantineGroup} from '@mantine/core';

/**
 * Horizontal flex group — design-layer pass-through over Mantine `Group`.
 * @registry Pass-through Mantine Group; import this instead of @mantine/core outside src/design.
 */
export const Group = MantineGroup;
